module.exports = __webpack_public_path__ + "img/ss8.7a4c5487.jpg";